import PropTypes from 'prop-types';
import React from 'react';
import { Map } from 'immutable';
import moment from 'moment';
import { Link } from 'react-router';
import ContextMenu from './contextMenus/relationshipTypeContext';
import Icon from '../ui/Icon/';

const RelationshipTypeCard = (props) => {
  const {
    projectId,
    relationshipType,
    onDelete,
    icons,
  } = props;

  const relationshipTypeId = relationshipType.get('id');
  const link = `/project/${projectId}/settings/relationship-type/${relationshipTypeId}`;
  const createdAt = relationshipType.get('created_at') ?
    moment(relationshipType.get('created_at')).format('MMM DD, YYYY') : 'N/A';

  const isLocked = relationshipType.getIn(['props', '_global', '_lock'], null);

  return (
    <div className="card-wrapper">
      <div className="card type-card element-type-card"
        style={{ borderTop: '2px solid #589f6c' }}
      >
        <div className="card-context">
          <ContextMenu link={link} onDelete={onDelete} relationshipTypeId={relationshipTypeId} isLocked={isLocked} />
        </div>
        <div className="card-body type-header type-header">
          <h3 className="type-name">
            <Icon
              iconId={relationshipType.get('icon_id')}
              entityType={'relationshipType'}
              icons={icons}
            />
            <Link to={link}>{relationshipType.get('type')}</Link>
          </h3>
        </div>
        <div className="type-details">
          <ul className="list-group">
            <li className="list-group-item">
              {relationshipType.get('description', 'NA')}
            </li>
            <li className="list-group-item">
              <i className="fa fa-clock-o" aria-hidden="true"></i> {createdAt}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

RelationshipTypeCard.propTypes = {
  projectId: PropTypes.string,
  relationshipType: PropTypes.instanceOf(Map),
  onDelete: PropTypes.func,
  icons: PropTypes.instanceOf(Map),
};

export default RelationshipTypeCard;



// WEBPACK FOOTER //
// ./src/components/cards/RelationshipTypeCard.js